import { render, staticRenderFns } from "./next-button.vue?vue&type=template&id=ff14f796&scoped=true&lang=pug&"
import script from "./next-button.vue?vue&type=script&lang=js&"
export * from "./next-button.vue?vue&type=script&lang=js&"
import style0 from "./next-button.vue?vue&type=style&index=0&id=ff14f796&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff14f796",
  null
  
)

export default component.exports